let isPullOrderPending = false;
let pullOrderTimeout = null;
let currentOrderRequest = null;
let sessionStartingToast = null;
let sessionReadyToast = null;
let isOnDevice = false;
let isSessionStarted = false;
let loginFailedToast = null;
let connectionLostToast = null;
let sessionFailedToast = null;
let sessionStartingToastTimeout = null;
let isMainPosDevice = true;

let reconnectingToast = null;

let accumulatedPrinted = {
  order_ids: new Set(),
  order_product_ids: new Set(),
  product_table_ids: new Set(),
  voided_ids: new Set(),
};

let startRetryTime = null;
const RETRY_DURATION_MS = 60000;

$(document).ready(function () {
  isOnDevice =
    $('body').attr('is_verifone') === '1' || $('body').attr('is_pax') === '1';
  const p = $('body').attr('p');
  const isPax = $('body').attr('is_pax') === '1';

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ action: 'web_view_ready', data: [] })
    );
    $.ajax({
      url: '/api/v1/check-login',
      method: 'GET',
      dataType: 'json',
    })
      .done(function (data) {
        if (data && data.isLoggedIn) {
          getOrderToPrint().always(() => {
            isPullOrderPending = false;
          });
        }
      })
      .fail(function (xhr, status, error) {
        console.error('Error fetching login status:', error);
      });

    function handleOrderPull(failedToPrintIds, printedIds) {
      let IdsToUpdate = failedToPrintIds || printedIds;

      if (IdsToUpdate) {
        localStorage.setItem('failedToPrintIds', JSON.stringify(IdsToUpdate));

        IdsToUpdate.order_ids?.forEach((id) =>
          accumulatedPrinted.order_ids.add(id)
        );
        IdsToUpdate.order_product_ids?.forEach((id) =>
          accumulatedPrinted.order_product_ids.add(id)
        );
        IdsToUpdate.product_table_ids?.forEach((id) =>
          accumulatedPrinted.product_table_ids.add(id)
        );
        IdsToUpdate.voided_ids?.forEach((id) =>
          accumulatedPrinted.voided_ids.add(id)
        );
      }

      if (isPullOrderPending) {
        cancelOrderPull();
      }

      if (pullOrderTimeout) {
        clearTimeout(pullOrderTimeout);
      }

      isPullOrderPending = true;

      pullOrderTimeout = setTimeout(() => {
        const toSend = {
          order_ids: Array.from(accumulatedPrinted.order_ids),
          order_product_ids: Array.from(accumulatedPrinted.order_product_ids),
          product_table_ids: Array.from(accumulatedPrinted.product_table_ids),
          voided_ids: Array.from(accumulatedPrinted.voided_ids),
        };

        // Remove only the IDs we're sending
        accumulatedPrinted.order_ids.clear();
        accumulatedPrinted.order_product_ids.clear();
        accumulatedPrinted.product_table_ids.clear();
        accumulatedPrinted.voided_ids.clear();

        currentOrderRequest = getOrderToPrint(toSend);
        currentOrderRequest.always(() => {
          isPullOrderPending = false;
          pullOrderTimeout = null;
          currentOrderRequest = null;
        });
      }, 7000);
    }

    // ── Helpers ──────────────────────────────────────────────────────────────

    function dismissReconnectingToast() {
      reconnectingToast?.close();
      reconnectingToast = null;
    }

    function setTerminalUnavailable() {
      const temrinalUniqueId = localStorage.getItem('temrinalUniqueId') || '';
      if (
        window.globalSocket &&
        window.globalSocket.readyState === WebSocket.OPEN
      ) {
        window.globalSocket.send(
          JSON.stringify({
            type: 'verifone',
            action: 'terminal_unavailable',
            temrinalUniqueId,
          })
        );
      }
    }

    function disableVerifonePaymentInputs() {
      if ($('#payment-split-modal').length) {
        $(
          ".payment-split-input[data-payment-method='payment_verifone_terminal']"
        ).prop('disabled', true);
        $(
          ".order-payment-split[data-payment-method='payment_verifone_terminal']"
        ).prop('disabled', true);
      }
      if ($('body').attr('is-verifone-session-started') === '1') {
        $('body').attr('is-verifone-session-started', '0');
      }
    }

    document.addEventListener('message', function (event) {
      const data = JSON.parse(event.data);

      switch (data.action) {
        case 'pull_order':
        case 'app_state_active':
          if (data.failedIds) {
            handleOrderPull(data.failedIds, null);
          } else {
            handleOrderPull(null, null);
          }
          break;
        case 'web_print_completed':
          const deviceId = data.deviceId;
          const { order_ids: orderIds } = data.data;
          const socketData = {
            type: 'web_print_completed',
            deviceId,
            orderIds,
          };
          window.globalSocket.send(JSON.stringify(socketData));
          break;
        case 'speech_search':
          appendProductSuggestions(event.data);
          break;
        case 'printer_discovery':
          const location_id = $(this).data('location-id');
          savedFoundPrinters(event.data, location_id);
          break;
        case 'sync_offline_data':
          synceOfflineData(data.data);
          break;
        case 'drawer_status':
          registerDrawerJournal(data.data);
          break;
        case 'verifone_state': {
          if (!isOnDevice) break;
          const { data: result } = data;
          if (!result) break;

          const p = $('body').attr('p');
          const posType = $('body').attr('pos_type');

          switch (result.state) {
            // ── Service is connecting / reconnecting ─────────────────────────
            case 'INITIALIZING':
            case 'RECONNECTING': {
              // Show a single persistent "reconnecting" toast and wait.
              // The service will broadcast SESSION_OPEN when ready.
              showReconnectingToast();
              disableVerifonePaymentInputs();
              isSessionStarted = false;

              if (p === 'payment_standby_mode') {
                setTerminalUnavailable();
              }
              break;
            }

            // ── Connected but not yet in a session (intermediate) ────────────
            case 'CONNECTED':
              // Service has connected and will proceed to login → session on
              // its own. Keep the reconnecting toast visible until SESSION_OPEN.
              showReconnectingToast();
              break;

            // ── Login failed / not logged in ─────────────────────────────────
            case 'NOT_LOGGED_IN': {
              showReconnectingToast();
              disableVerifonePaymentInputs();
              isSessionStarted = false;

              if (p === 'payment_standby_mode') {
                setTerminalUnavailable();
                window.showConnectionLost?.();
              } else if (p === 'events' && !!posType) {
                loginFailedToast?.close();
                loginFailedToast = showToast({
                  type: 'info',
                  message:
                    'Verifone pålogging mislyktes. Vennligst prøv igjen eller kontakt oss.',
                  autoHide: false,
                  closeButton: true,
                });
              }
              break;
            }

            // ── Connection dropped ───────────────────────────────────────────
            case 'CONNECTION_LOST':
            case 'UNKNOWN': {
              isSessionStarted = false;
              disableVerifonePaymentInputs();
              showReconnectingToast();

              if (p === 'payment_standby_mode') {
                window.showConnectionLost?.();
                setTerminalUnavailable();
              } else {
                connectionLostToast?.close();
                connectionLostToast = showToast({
                  type: 'info',
                  message:
                    'Terminalforbindelsen er brutt. Prøver å koble til igjen...',
                  position: 'bottom-center',
                  autoHide: false,
                  closeButton: true,
                });
              }
              break;
            }

            // ── Logged in — service will open a session automatically ────────
            case 'LOGGED_IN': {
              // Just keep the reconnecting toast up; SESSION_OPEN is next.
              showReconnectingToast();
              isSessionStarted = false;
              break;
            }

            // ── Session open — terminal is ready ─────────────────────────────
            case 'SESSION_OPEN': {
              isSessionStarted = true;
              $('body').attr('is-verifone-session-started', '1');

              // Dismiss all pending toasts
              dismissReconnectingToast();
              sessionStartingToast?.close();
              sessionStartingToast = null;
              loginFailedToast?.close();
              loginFailedToast = null;
              connectionLostToast?.close();
              connectionLostToast = null;
              sessionFailedToast?.close();
              sessionFailedToast = null;
              sessionReadyToast = 1;

              if ($('#pax-poiid-modal.show').length) {
                $('#pax-poiid-modal').modal('hide');
              }

              // Enable inputs
              if ($('#payment-split-modal').length) {
                $(
                  ".payment-split-input[data-payment-method='payment_verifone_terminal']"
                ).prop('disabled', false);
                $(
                  ".order-payment-split[data-payment-method='payment_verifone_terminal']"
                ).prop('disabled', false);
              }
              $(
                ".quick-order-button[data-payment-method='payment_verifone_terminal']"
              ).prop('disabled', false);

              if (p === 'payment_standby_mode') {
                if (!$('#paymentStatus').hasClass('success')) {
                  window.resetToWaiting?.();
                }
                const temrinalUniqueId =
                  localStorage.getItem('temrinalUniqueId') || '';

                sendWhenReady(
                  window.globalSocket,
                  JSON.stringify({
                    type: 'verifone',
                    action: 'terminal_available',
                    temrinalUniqueId,
                  })
                ).catch((err) =>
                  console.error('Failed to send verifone message:', err)
                );
              }
              break;
            }

            // ── Session failed to start ───────────────────────────────────────
            case 'SESSION_START_FAILED': {
              isSessionStarted = false;
              disableVerifonePaymentInputs();
              showReconnectingToast();

              if (p === 'payment_standby_mode') {
                setTerminalUnavailable();
                window.showConnectionLost?.();
              } else {
                sessionFailedToast?.close();
                sessionFailedToast = showToast({
                  type: 'info',
                  message:
                    'Verifone terminal økt start mislyktes. Prøver på nytt...',
                  autoHide: false,
                  closeButton: true,
                });
              }
              break;
            }
          }
          break;
        }
        case 'payment_completed': {
          const { data: result } = data;
          const [orderId, orderPaymentSplitId] = String(result.orderId).split(
            '-'
          );
          paymentProcessDataToRetry = JSON.parse(
            localStorage.getItem('verifone_payment_data') || 'null'
          );
          localStorage.removeItem('verifone_payment_data');
          const verifoneProcessData = JSON.parse(
            localStorage.getItem('verifoneProcessData') || 'null'
          );
          const temrinalUniqueId =
            localStorage.getItem('temrinalUniqueId') || '';
          if (verifonePaymentProcessInterval) {
            clearInterval(verifonePaymentProcessInterval);
            verifonePaymentProcessInterval = null;
          }
          if (result.authResult === 'AUTHORIZED') {
            if (
              result.responseData !== undefined &&
              result.responseData !== null
            ) {
              const response = result.responseData;
              let redirectUrl = '';
              if (response.redirectUrl) {
                redirectUrl = response.redirectUrl;
              }
              if (response.success) {
                popupAlert();
                if (verifoneProcessData) {
                  if (typeof window.showPaymentSuccess === 'function') {
                    window.showPaymentSuccess();
                  }

                  const completedInfo = {
                    confirmation_html: '',
                    item_count: 0,
                    total_amount: 0,
                    temrinalUniqueId,
                    tableSessionId: response.table_session_id || null,
                    orderPaymentSplitId: orderPaymentSplitId || null,
                    posSale: response.posSale || null,
                  };

                  if (response.order_html && response.order_html !== '') {
                    completedInfo.order_html = response.order_html;
                  }

                  if (response.item_count && response.total_amount) {
                    completedInfo.item_count = response.item_count;
                    completedInfo.total_amount = response.total_amount;
                  }

                  let orderProducts = [];
                  if (
                    response.order_products &&
                    Array.isArray(response.order_products)
                  ) {
                    orderProducts = response.order_products;
                  }

                  if (
                    isOnDevice &&
                    verifoneProcessData.senderDeviceId ==
                      localStorage.getItem('deviceID')
                  ) {
                    passTerminalDataToWebView({
                      action: 'verifone',
                      data: {
                        action: 'print',
                        data: {
                          document: response.print_document,
                          contentTypeString: 'HTML',
                          receiptTypeString: 'DOCUMENT',
                          deliveryMethodString: 'PRINT',
                          deliveryAddress: '',
                        },
                      },
                    });
                  }

                  sendWhenReady(
                    window.globalSocket,
                    JSON.stringify({
                      type: 'verifone',
                      action: 'completed_payment',
                      deviceId: verifoneProcessData.senderDeviceId,
                      senderDeviceId: localStorage.getItem('deviceID'),
                      completedInfo,
                      orderProducts,
                      redirectUrl,
                    })
                  );

                  setTimeout(() => {
                    localStorage.removeItem('verifoneProcessData');
                  }, 1500);
                } else {
                  if ($('#paymentProcessModal').hasClass('show')) {
                    $('#paymentProcessModal').modal('hide');
                  }

                  if (orderPaymentSplitId && response.success) {
                    const splitInput = $(
                      `.payment-split-input[data-payment-method='payment_verifone_terminal']`
                    );
                    const splitButton = $(
                      `.order-payment-split[data-payment-method='payment_verifone_terminal']`
                    );
                    splitButton.find('div.loader').remove();
                    splitButton.attr('disabled', false);
                    $('#split-methods-select').attr('disabled', false);
                    splitButton.text(splitButton.attr('data-original-text'));
                    const paidAmount = parseFloat(splitInput.val());
                    splitInput.val('');

                    let totalAmount = parseFloat(
                      splitInput.attr('data-max-allowed')
                    );
                    const remainingAmout = parseFloat(
                      $('#total-amount').attr('data-total-amount')
                    );
                    const totalPaid = totalAmount - remainingAmout + paidAmount;
                    if (totalPaid > 0) {
                      const remainingValue =
                        (totalAmount * 100 - totalPaid * 100) / 100;
                      $('#total-amount').text(
                        `Gjenværende totalt: ${formattedPriceToShow(remainingValue)}`
                      );
                      $('#total-amount').attr(
                        'data-total-amount',
                        remainingValue
                      );

                      $('#payment-split-input').attr(
                        'data-max-allowed',
                        remainingValue
                      );
                    }
                  }

                  if (
                    response.table_session_id !== null &&
                    response.table_session_id !== undefined
                  ) {
                    emptyAllCart(
                      'completed_share_by_amount',
                      response.table_session_id
                    );
                  }

                  if (response.posSale && response.posSale == 2) {
                    showToast({
                      type: 'success',
                      message: 'Veksel vellykket',
                      duration: 2000,
                    });
                    $('#cash-exchange-input').val('');
                  } else {
                    const $confirmationStyle = $(
                      '#classic-location-products'
                    ).data('order-confirmation-toast-style');
                    if (response.order_html && response.order_html !== '') {
                      $('.confirmation-toast').remove();
                      $('#content').append(
                        '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                          (window.innerWidth >= 500 ? ' right: 0;' : '') +
                          ' width: 480px; display: none;">' +
                          '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                          ($confirmationStyle == 'compact' ? 'false' : 'true') +
                          '" data-delay="' +
                          ($confirmationStyle === 'compact' ? 100000 : 3000) +
                          '">' +
                          '  <div class="toast-header">' +
                          '    <strong class="mr-auto">Ordre registrert</strong>' +
                          '    <small></small>' +
                          '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                          '      <span aria-hidden="true">&times;</span>' +
                          '    </button>' +
                          '  </div>' +
                          '  <div class="toast-body">' +
                          response.order_html +
                          '  </div>' +
                          '</div>' +
                          '</div>'
                      );
                    }

                    if (response.item_count && response.total_amount) {
                      sessionReadyToast = null;
                      isSessionStarted = false;

                      if ($('#payment-split-modal').length) {
                        $('#payment-split-modal').modal('hide');
                      }

                      if ($confirmationStyle === 'compact') {
                        showPreviousSaleBar(
                          response.item_count,
                          response.total_amount
                        );
                      } else {
                        $('.confirmation-toast')
                          .css({ padding: '1rem' })
                          .show();
                        $('.confirmation-toast-box')
                          .toast('show')
                          .on('hidden.bs.toast', function () {
                            $('.confirmation-toast').attr(
                              'style',
                              function (i, s) {
                                return (s || '') + 'padding: 0px !important;';
                              }
                            );
                          });
                      }

                      if (
                        response.order_products &&
                        response.order_products.length > 0
                      ) {
                        const orderProducts = response.order_products;
                        const productsWithCount = [];

                        orderProducts.forEach((product) => {
                          const productDetail = `(${product.quantity})${product.name}`;
                          productsWithCount.push(productDetail);
                        });

                        localStorage.setItem(
                          'lastOrderProducts',
                          JSON.stringify(productsWithCount)
                        );
                        localStorage.setItem(
                          'lastOrderTotal',
                          response.total_amount
                        );

                        setLastOrderDetails();
                      }

                      emptyAllCart();
                      closePanel();
                    }
                  }
                }

                if (redirectUrl) {
                  document.location.href = redirectUrl;
                }
              }
            }
            // else {
            //   const [orderId, orderPaymentSplitId] = String(
            //     result.orderId
            //   ).split('-');
            //   const paymentData = result.paymentData;
            //   const tipAmount = result?.tipAmount || 0;

            //   $.ajax({
            //     url: '/api/v1/private/order/complete-verifone-order',
            //     method: 'POST',
            //     dataType: 'json',
            //     data: {
            //       order_id: orderId,
            //       card_type: result.cardType || '',
            //       order_payment_split_id: orderPaymentSplitId || null,
            //       order_params: paymentData?.orderParams || null,
            //       terminal_id: verifoneSerialNumber,
            //       tip_amount: tipAmount,
            //     },
            //   })
            //     .done(function (response) {
            //       let redirectUrl = '';
            //       if (response.redirectUrl) {
            //         redirectUrl = response.redirectUrl;
            //       }
            //       if (response.success) {
            //         if (verifoneProcessData) {
            //           if (typeof window.showPaymentSuccess === 'function') {
            //             window.showPaymentSuccess();
            //           }

            //           const completedInfo = {
            //             confirmation_html: '',
            //             item_count: 0,
            //             total_amount: 0,
            //             verifoneSerialNumber,
            //             tableSessionId: response.table_session_id || null,
            //             orderPaymentSplitId: orderPaymentSplitId || null,
            //           };

            //           if (response.order_html && response.order_html !== '') {
            //             completedInfo.order_html = response.order_html;
            //           }

            //           if (response.item_count && response.total_amount) {
            //             completedInfo.item_count = response.item_count;
            //             completedInfo.total_amount = response.total_amount;
            //           }

            //           let orderProducts = [];
            //           if (
            //             response.order_products &&
            //             Array.isArray(response.order_products)
            //           ) {
            //             orderProducts = response.order_products;
            //           }

            //           if (
            //             isVerifone &&
            //             verifoneProcessData.senderDeviceId ==
            //               localStorage.getItem('deviceID')
            //           ) {
            //             passVerifoneDataToWebView({
            //               action: 'verifone',
            //               data: {
            //                 action: 'print',
            //                 data: {
            //                   document: response.print_document,
            //                   contentTypeString: 'HTML',
            //                   receiptTypeString: 'DOCUMENT',
            //                   deliveryMethodString: 'PRINT',
            //                   deliveryAddress: '',
            //                 },
            //               },
            //             });
            //           }

            //           sendWhenReady(
            //             window.globalSocket,
            //             JSON.stringify({
            //               type: 'verifone',
            //               action: 'completed_payment',
            //               deviceId: verifoneProcessData.senderDeviceId,
            //               senderDeviceId: localStorage.getItem('deviceID'),
            //               completedInfo,
            //               orderProducts,
            //               redirectUrl,
            //             })
            //           );

            //           setTimeout(() => {
            //             localStorage.removeItem('verifoneProcessData');
            //           }, 1500);
            //         } else {
            //           if ($('#paymentProcessModal').hasClass('show')) {
            //             $('#paymentProcessModal').modal('hide');
            //           }

            //           if (orderPaymentSplitId && response.success) {
            //             const splitInput = $(
            //               `.payment-split-input[data-payment-method='payment_verifone_terminal']`
            //             );
            //             const splitButton = $(
            //               `.order-payment-split[data-payment-method='payment_verifone_terminal']`
            //             );
            //             splitButton.find('div.loader').remove();
            //             splitButton.attr('disabled', false);
            //             $('#split-methods-select').attr('disabled', false);
            //             splitButton.text(
            //               splitButton.attr('data-original-text')
            //             );
            //             const paidAmount = parseFloat(splitInput.val());
            //             splitInput.val('');

            //             let totalAmount = parseFloat(
            //               splitInput.attr('data-max-allowed')
            //             );
            //             const remainingAmout = parseFloat(
            //               $('#total-amount').attr('data-total-amount')
            //             );
            //             const totalPaid =
            //               totalAmount - remainingAmout + paidAmount;
            //             if (totalPaid > 0) {
            //               const remainingValue =
            //                 (totalAmount * 100 - totalPaid * 100) / 100;
            //               $('#total-amount').text(
            //                 `Gjenværende totalt: ${formattedPriceToShow(remainingValue)}`
            //               );
            //               $('#total-amount').attr(
            //                 'data-total-amount',
            //                 remainingValue
            //               );

            //               $('#payment-split-input').attr(
            //                 'data-max-allowed',
            //                 remainingValue
            //               );
            //             }
            //           }

            //           if (
            //             response.table_session_id !== null &&
            //             response.table_session_id !== undefined
            //           ) {
            //             emptyAllCart(
            //               'completed_share_by_amount',
            //               response.table_session_id
            //             );
            //           }

            //           const $confirmationStyle = $(
            //             '#classic-location-products'
            //           ).data('order-confirmation-toast-style');
            //           if (response.order_html && response.order_html !== '') {
            //             $('.confirmation-toast').remove();
            //             $('#content').append(
            //               '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
            //                 (window.innerWidth >= 500 ? ' right: 0;' : '') +
            //                 ' width: 480px; display: none;">' +
            //                 '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
            //                 ($confirmationStyle == 'compact'
            //                   ? 'false'
            //                   : 'true') +
            //                 '" data-delay="' +
            //                 ($confirmationStyle === 'compact' ? 100000 : 3000) +
            //                 '">' +
            //                 '  <div class="toast-header">' +
            //                 '    <strong class="mr-auto">Ordre registrert</strong>' +
            //                 '    <small></small>' +
            //                 '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
            //                 '      <span aria-hidden="true">&times;</span>' +
            //                 '    </button>' +
            //                 '  </div>' +
            //                 '  <div class="toast-body">' +
            //                 response.order_html +
            //                 '  </div>' +
            //                 '</div>' +
            //                 '</div>'
            //             );
            //           }

            //           if (response.item_count && response.total_amount) {
            //             sessionReadyToast = null;
            //             isSessionStarted = false;

            //             if ($('#payment-split-modal').length) {
            //               $('#payment-split-modal').modal('hide');
            //             }

            //             if ($confirmationStyle === 'compact') {
            //               showPreviousSaleBar(
            //                 response.item_count,
            //                 response.total_amount
            //               );
            //             } else {
            //               $('.confirmation-toast')
            //                 .css({ padding: '1rem' })
            //                 .show();
            //               $('.confirmation-toast-box')
            //                 .toast('show')
            //                 .on('hidden.bs.toast', function () {
            //                   $('.confirmation-toast').attr(
            //                     'style',
            //                     function (i, s) {
            //                       return (s || '') + 'padding: 0px !important;';
            //                     }
            //                   );
            //                 });
            //             }

            //             if (
            //               response.order_products &&
            //               response.order_products.length > 0
            //             ) {
            //               const orderProducts = response.order_products;
            //               const productsWithCount = [];

            //               orderProducts.forEach((product) => {
            //                 const productDetail = `(${product.quantity})${product.name}`;
            //                 productsWithCount.push(productDetail);
            //               });

            //               localStorage.setItem(
            //                 'lastOrderProducts',
            //                 JSON.stringify(productsWithCount)
            //               );
            //               localStorage.setItem(
            //                 'lastOrderTotal',
            //                 response.total_amount
            //               );

            //               setLastOrderDetails();
            //             }

            //             emptyAllCart();
            //             closePanel();
            //           }
            //         }

            //         if (redirectUrl) {
            //           document.location.href = redirectUrl;
            //         }
            //       }
            //     })
            //     .fail(function (data) {
            //       if (
            //         data.responseJSON.redirect_url !== undefined &&
            //         data.responseJSON.redirect_url !== null
            //       ) {
            //         document.location.href = data.responseJSON.redirect_url;
            //       }
            //     });
            // }
          } else if (result.authResult === 'DECLINED') {
            if (verifoneProcessData) {
              window.showPaymentFailed();
              window.globalSocket.send(
                JSON.stringify({
                  type: 'verifone',
                  action: 'declined_payment',
                  deviceId: verifoneProcessData.senderDeviceId,
                  senderDeviceId: localStorage.getItem('deviceID'),
                  temrinalUniqueId,
                })
              );
              setTimeout(() => {
                localStorage.removeItem('verifoneProcessData');
              }, 1500);
            } else {
              $('#paymentProcessSpinner').addClass('d-none');
              $('#paymentProcessError').removeClass('d-none');
              const declinedMessage =
                $('#paymentStatus').data('declined-message') ||
                'Payment Declined';
              $('#paymentStatus').text(declinedMessage);
              $('#retryPaymentButton').removeClass('d-none');
              $('#cancelPaymentButton')
                .text($('#cancelPaymentButton').data('button-text') || 'Avbryt')
                .prop('disabled', false);

              sessionReadyToast = null;
              isSessionStarted = false;

              const splitButton = $(
                `.order-payment-split[data-payment-method='payment_verifone_terminal']`
              );
              $('#payment-split-input').attr('disabled', false);
              splitButton.find('div.loader').remove();
              splitButton.attr('disabled', false);
              splitButton.text(splitButton.attr('data-original-text'));

              paymentData = result.paymentData;
            }
          } else if (result.authResult === 'USER_CANCELLED') {
            if ($('#cancel-last-order-confirm-modal').length > 0) {
              showToast({
                message: 'Beklager, Ikke klarer å avbryte',
                type: 'error',
                position: 'bottom-center',
              });
              $('#cancel-last-order-confirm-modal').modal('hide');
            }

            if (verifoneProcessData) {
              window.showPaymentFailed();
              window.globalSocket.send(
                JSON.stringify({
                  type: 'verifone',
                  action: 'user_cancelled_payment',
                  deviceId: verifoneProcessData.senderDeviceId,
                  senderDeviceId: localStorage.getItem('deviceID'),
                  temrinalUniqueId,
                })
              );
              setTimeout(() => {
                localStorage.removeItem('verifoneProcessData');
              }, 1500);
            } else {
              $('#paymentProcessSpinner').addClass('d-none');
              $('#paymentProcessError').removeClass('d-none');
              const userCancelledMessage =
                $('#paymentStatus').data('user-cancelled-message') ||
                'Payment Cancelled by User';
              $('#paymentStatus').text(userCancelledMessage);
              $('#retryPaymentButton').removeClass('d-none');
              $('#cancelPaymentButton')
                .text($('#cancelPaymentButton').data('button-text') || 'Avbryt')
                .prop('disabled', false);
              sessionReadyToast = null;
              isSessionStarted = false;

              const splitButton = $(
                `.order-payment-split[data-payment-method='payment_verifone_terminal']`
              );
              $('#payment-split-input').attr('disabled', false);
              splitButton.find('div.loader').remove();
              splitButton.attr('disabled', false);
              splitButton.text(splitButton.attr('data-original-text'));

              paymentData = result.paymentData;
            }
          } else {
            if (verifoneProcessData) {
              if (window.showPaymentFailed) {
                window.showPaymentFailed();
              }
              if (
                window.globalSocket &&
                window.globalSocket.readyState === WebSocket.OPEN
              ) {
                window.globalSocket.send(
                  JSON.stringify({
                    type: 'verifone',
                    action: 'de',
                    deviceId: verifoneProcessData.senderDeviceId,
                    senderDeviceId: localStorage.getItem('deviceID'),
                    temrinalUniqueId,
                  })
                );
              }
              setTimeout(() => {
                localStorage.removeItem('verifoneProcessData');
              }, 1500);
            } else {
              $('#paymentProcessSpinner').addClass('d-none');
              $('#paymentProcessError').removeClass('d-none');
              const userCancelledMessage =
                $('#paymentStatus').data('user-cancelled-message') ||
                'Payment Cancelled by User';
              $('#paymentStatus').text(userCancelledMessage);
              $('#retryPaymentButton').removeClass('d-none');
              $('#cancelPaymentButton')
                .text($('#cancelPaymentButton').data('button-text') || 'Avbryt')
                .prop('disabled', false);

              sessionReadyToast = null;
              isSessionStarted = false;

              const splitButton = $(
                `.order-payment-split[data-payment-method='payment_verifone_terminal']`
              );
              $('#payment-split-input').attr('disabled', false);
              splitButton.find('div.loader').remove();
              splitButton.attr('disabled', false);
              splitButton.text(splitButton.attr('data-original-text'));

              paymentData = result.paymentData;
            }
          }
          isTerminalBusy = false;
          break;
        }
        case 'refund_completed': {
          const { data: result } = data;

          if (result.authResult === 'REFUNDED') {
            if (
              result.responseData !== undefined &&
              result.responseData !== null
            ) {
              const { orderId } = result;
              let isAddStockBack = result.isAddStockBack;
              let isDeleteOrder = result.isDeleteOrder;
              let returnedOrderId = result.returnedOrderId || null;
              let orderPaymentSplitId = result.orderPaymentSplitId || null;

              const responseData = result.responseData;

              const verifoneProcessData = JSON.parse(
                localStorage.getItem('verifoneProcessData') || 'null'
              );

              if (
                responseData &&
                responseData.success &&
                !responseData.isSplitedPaymentOrder
              ) {
                if (verifoneProcessData) {
                  if (typeof window.showPaymentSuccess === 'function') {
                    window.showPaymentSuccess();
                  }

                  sendWhenReady(
                    window.globalSocket,
                    JSON.stringify({
                      type: 'verifone',
                      action: 'completed_refund',
                      deviceId: verifoneProcessData.senderDeviceId,
                      senderDeviceId: localStorage.getItem('deviceID'),
                      redirectUrl: responseData.redirect_url || null,
                      returnedOrderId: responseData.returnedOrderId || null,
                    })
                  ).catch((err) =>
                    console.error('Failed to send verifone message:', err)
                  );
                }
                popupAlert();
                $('.return-order-success-section ').removeClass('d-none');
                $('.return-order-progress-section').addClass('d-none');
                setTimeout(() => {
                  localStorage.removeItem('verifoneProcessData');
                  localStorage.removeItem('verifone_refund_data');
                  if ($('#cancel-last-order-confirm-modal').length) {
                    $('#cancel-last-order-confirm-modal').modal('hide');
                  }
                  if (p == 'statistic_order') {
                    getAmountOfOrderAndSale(
                      startDate,
                      endDate,
                      period,
                      supplierId,
                      productGroupUniqueId,
                      locationId,
                      userId,
                      platform,
                      customPeriod,
                      topProductGroupUniqueId,
                      customerId,
                      compareBy,
                      productId,
                      vatCode,
                      paymentMethod
                    );
                    $('.modal-backdrop').remove();
                  } else if (p == 'today_orders') {
                    $('#return-order-progress-modal').modal('hide');
                    $(
                      `tr[data-order-id="${responseData.returnedOrderId}"]`
                    ).fadeOut(400, function () {
                      $(this).remove();
                    });
                    $(
                      `ul[data-order-id="${responseData.returnedOrderId}"]`
                    ).fadeOut(400, function () {
                      $(this).remove();
                    });
                  } else if (
                    p == 'order_confirmation' &&
                    responseData.redirect_url
                  ) {
                    document.location.href = responseData.redirect_url;
                  }
                }, 1500);
              } else if (
                responseData &&
                responseData.returnedOrderId &&
                !responseData.refund_data
              ) {
                $('#returnOrderPaymentSplitModel .close').addClass('d-none');
                $('#returnOrderPaymentSplitModel').attr(
                  'data-returned-order-id',
                  responseData.returnedOrderId
                );
                localStorage.setItem(
                  'returningOrderData',
                  JSON.stringify({
                    orderId,
                    addStockBack: isAddStockBack ? '1' : '0',
                    returnedOrderId: responseData.returnedOrderId,
                  })
                );
                const button = $(
                  `.order-payment-split-return-button[data-order-payment-split-id='${orderPaymentSplitId}']`
                );
                button.attr('data-is-paid', 1);

                $(".order-payment-split-return-button[data-is-paid='0']").prop(
                  'disabled',
                  false
                );

                $('.return-order-error').remove();
              }
              setTimeout(() => {
                localStorage.removeItem('verifoneProcessData');
                localStorage.removeItem('verifone_refund_data');
              }, 1500);
            }
            // else {
            //   const { orderId, verifoneId } = result;
            //   let isAddStockBack = true;
            //   let returnedOrderId = null;
            //   let orderPaymentSplitId = null;

            //   const verifoneProcessData = JSON.parse(
            //     localStorage.getItem('verifoneProcessData') || 'null'
            //   );

            //   const refundData =
            //     JSON.parse(localStorage.getItem('verifone_refund_data')) ||
            //     null;

            //   if (refundData) {
            //     isAddStockBack = refundData.isAddStockBack;
            //     returnedOrderId = refundData.returnedOrderId || null;
            //     orderPaymentSplitId = refundData.orderPaymentSplitId || null;
            //   } else if (verifoneProcessData) {
            //     isAddStockBack = verifoneProcessData.paymentData.isAddStockBack;
            //   }

            //   $.ajax({
            //     url: '/api/v1/private/order/complete-verifone-order-reutrn',
            //     method: 'POST',
            //     dataType: 'json',
            //     data: {
            //       orderId,
            //       isAddStockBack,
            //       returnedOrderId,
            //     },
            //   })
            //     .done(function (data) {
            //       if (data && data.success && !data.isSplitedPaymentOrder) {
            //         if (verifoneProcessData) {
            //           if (typeof window.showPaymentSuccess === 'function') {
            //             window.showPaymentSuccess();
            //           }

            //           sendWhenReady(
            //             window.globalSocket,
            //             JSON.stringify({
            //               type: 'verifone',
            //               action: 'completed_refund',
            //               deviceId: verifoneProcessData.senderDeviceId,
            //               senderDeviceId: localStorage.getItem('deviceID'),
            //               redirectUrl: data.redirect_url || null,
            //               returnedOrderId: data.returnedOrderId || null,
            //             })
            //           ).catch((err) =>
            //             console.error('Failed to send verifone message:', err)
            //           );
            //         }

            //         $('.return-order-success-section ').removeClass('d-none');
            //         $('.return-order-progress-section').addClass('d-none');
            //         setTimeout(() => {
            //           localStorage.removeItem('verifoneProcessData');
            //           localStorage.removeItem('verifone_refund_data');
            //           if (p == 'statistic_order') {
            //             getAmountOfOrderAndSale(
            //               startDate,
            //               endDate,
            //               period,
            //               supplierId,
            //               productGroupUniqueId,
            //               locationId,
            //               userId,
            //               platform,
            //               customPeriod,
            //               topProductGroupUniqueId,
            //               customerId,
            //               compareBy,
            //               productId,
            //               vatCode,
            //               paymentMethod
            //             );
            //             $('.modal-backdrop').remove();
            //           } else if (p == 'today_orders') {
            //             $('#return-order-progress-model').modal('hide');
            //             $(
            //               `tr[data-order-id="${data.returnedOrderId}"]`
            //             ).fadeOut(400, function () {
            //               $(this).remove();
            //             });
            //             $(
            //               `ul[data-order-id="${data.returnedOrderId}"]`
            //             ).fadeOut(400, function () {
            //               $(this).remove();
            //             });
            //           } else if (
            //             p == 'order_confirmation' &&
            //             data.redirect_url
            //           ) {
            //             document.location.href = data.redirect_url;
            //           }
            //         }, 1500);
            //       } else if (
            //         data &&
            //         data.returnedOrderId &&
            //         !data.refund_data
            //       ) {
            //         $('#returnOrderPaymentSplitModel .close').addClass(
            //           'd-none'
            //         );
            //         $('#returnOrderPaymentSplitModel').attr(
            //           'data-returned-order-id',
            //           data.returnedOrderId
            //         );
            //         localStorage.setItem(
            //           'returningOrderData',
            //           JSON.stringify({
            //             orderId,
            //             addStockBack: isAddStockBack ? '1' : '0',
            //             returnedOrderId: data.returnedOrderId,
            //           })
            //         );
            //         const button = $(
            //           `.order-payment-split-return-button[data-order-payment-split-id='${orderPaymentSplitId}']`
            //         );
            //         button.attr('data-is-paid', 1);

            //         $(
            //           ".order-payment-split-return-button[data-is-paid='0']"
            //         ).prop('disabled', false);

            //         $('.return-order-error').remove();
            //       }
            //       setTimeout(() => {
            //         localStorage.removeItem('verifoneProcessData');
            //         localStorage.removeItem('verifone_refund_data');
            //       }, 1500);
            //     })
            //     .fail(function (data) {
            //       if (
            //         data.responseJSON.errors !== undefined &&
            //         data.responseJSON.errors !== null
            //       ) {
            //         let errorMessage = '';
            //         if (data.responseJSON.errors.includes('/')) {
            //           errorMessage = data.responseJSON.errors.split('/')[0];
            //         } else {
            //           errorMessage = data.responseJSON.errors;
            //         }

            //         $('.return-order-progress-section').addClass('d-none');
            //         $('.return-error-message-section').removeClass('d-none');
            //         $(
            //           '.return-error-message-section .return-error-message'
            //         ).text(errorMessage);
            //         $('.return-order-progress-action-btn').prop(
            //           'disabled',
            //           false
            //         );
            //       }

            //       setTimeout(() => {
            //         localStorage.removeItem('verifoneProcessData');
            //       }, 1500);
            //     });
            // }
          } else {
            let errorMessage = 'Ikke klarer å retur !';

            $('.return-order-progress-section').addClass('d-none');
            $('.return-error-message-section').removeClass('d-none');
            $('.return-error-message-section .return-error-message').text(
              errorMessage
            );
            $('.return-order-progress-action-btn').prop('disabled', false);
            const verifoneProcessData = JSON.parse(
              localStorage.getItem('verifoneProcessData') || 'null'
            );

            if (verifoneProcessData) {
              sendWhenReady(
                window.globalSocket,
                JSON.stringify({
                  type: 'verifone',
                  action: 'declined_refund',
                  deviceId: verifoneProcessData.senderDeviceId,
                  senderDeviceId: localStorage.getItem('deviceID'),
                })
              ).catch((err) =>
                console.error('Failed to send verifone message:', err)
              );
            }
          }
          isTerminalBusy = false;
          break;
        }
        case 'device_info': {
          const { data: result } = data;
          if ((result?.isVerifone || result?.isPax) && result) {
            $('.device-information-section').removeClass('d-none');
            var deviceData = result;
            let terminaDeviceUniqueId = '';
            if (result.isPax) {
              terminaDeviceUniqueId = deviceData.serialNumber || '';
            } else {
              terminaDeviceUniqueId =
                deviceData.serialNumber?.replace(/-/g, '') || '';
            }

            $('#appVersion').text(deviceData.applicationVersion || 'N/A');
            $('#paymentAppName').text(deviceData.paymentAppName || 'N/A');
            $('#paymentAppVersion').text(deviceData.paymentAppVersion || 'N/A');
            $('#serialNumber').text(deviceData.serialNumber || 'N/A');
            $('#uniqueId').text(deviceData.uniqueId || 'N/A');

            if ($('.navbar-brand').length) {
              $('.navbar-brand').attr(
                'data-terminal-serial-number',
                terminaDeviceUniqueId || ''
              );
            }

            localStorage.setItem('temrinalUniqueId', terminaDeviceUniqueId);
            if (!!result.poiId) {
              localStorage.setItem('poiId', result.poiId);
            } else {
              localStorage.removeItem('poiId');
              if (isPax && p !== 'frontpage' && p !== 'login') {
                $('#pax-poiid-modal').modal('show');
              }
            }
          }

          if (result?.applicationVersion) {
            if (
              $('#footer-android-build-version').length &&
              $('#footer-android-build-version').hasClass('d-none')
            ) {
              $('#footer-android-build-version')
                .text(
                  'Application version: ' + (result.applicationVersion || 'N/A')
                )
                .removeClass('d-none');
            }
          }
        }
      }
    });

    window.addEventListener('message', function (event) {
      const data = JSON.parse(event.data);

      switch (data.action) {
        case 'pull_order':
        case 'app_state_active':
          handleOrderPull(data.data);
          break;
        case 'web_print_completed':
          const deviceId = data.deviceId;
          const { order_ids: orderIds } = data.data;
          const socketData = {
            type: 'web_print_completed',
            deviceId,
            orderIds,
          };
          window.globalSocket.send(JSON.stringify(socketData));
          break;
        case 'speech_search':
          appendProductSuggestions(event.data);
          break;
        case 'printer_discovery':
          const location_id = $(this).data('location-id');
          savedFoundPrinters(event.data, location_id);
          break;
        case 'sync_offline_data':
          synceOfflineData(data.data);
          break;
        case 'drawer_status':
          registerDrawerJournal(data.data);
          break;
      }
    });
  }
});

function showReconnectingToast() {
  if (reconnectingToast) {
    reconnectingToast.close?.();
    reconnectingToast = null;
  }

  reconnectingToast = showToast({
    message: 'Vent litt! Prøver å koble til igjen...',
    position: 'bottom-center',
    autoHide: false,
    closeButton: true,
    onClose: () => {
      reconnectingToast = null;
    },
  });
}

function checkVerifoneSDKState() {
  if (
    $('body').attr('is_verifone') == 1 &&
    $('body').attr('data-is-logged-in') == 1
  ) {
    passTerminalDataToWebView({
      action: 'verifone',
      data: {
        action: 'check_state',
      },
    });
  }

  showReconnectingToast();
}

function cancelOrderPull() {
  if (currentOrderRequest) {
    currentOrderRequest.abort();
    currentOrderRequest = null;
  }

  if (pullOrderTimeout) {
    clearTimeout(pullOrderTimeout);
    pullOrderTimeout = null;
  }

  isPullOrderPending = false;
}
